import type React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "~/store";

// 有償プラン受付停止（2026/10/29〜）のため、URL 直打ちでも実行させず支払いとプランへ戻す
const PlanChangePage: React.FC = () => {
  const { organization } = useSelector((state: RootState) => state.auth);

  if (!organization) return null;

  return <Navigate to={`/${organization.id}/billings`} replace />;
};

export default PlanChangePage;
